document.addEventListener("DOMContentLoaded", function() {
  const container = document.querySelector('.collection-scroll-container');
  if (!container) return;

  // Retrieve offset setting passed from Liquid
  const baseOffset = parseInt(container.dataset.stickyOffset) || 0;
  // Add 60px breathing room so title isn't hidden behind nav
  const scrollOffset = baseOffset + 60; 

  // 1. Smooth Scroll on Click
  const links = container.querySelectorAll('.js-scroll-link');

  links.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      const targetId = this.getAttribute('href');
      const targetSection = document.querySelector(targetId);
      
      if (targetSection) {
        const topPos = targetSection.getBoundingClientRect().top + window.scrollY - scrollOffset;
        window.scrollTo({
          top: topPos,
          behavior: 'smooth'
        });
      }
    });
  });

  // 2. Active State on Scroll (IntersectionObserver)
  const sections = container.querySelectorAll('.collection-row');
  const navItems = container.querySelectorAll('.sub-nav-item');

  const observerOptions = {
    root: null,
    // Adjust rootMargin to trigger the active state slightly before the element hits the top
    rootMargin: '-20% 0px -60% 0px', 
    threshold: 0
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Remove active class from all
        navItems.forEach(link => link.classList.remove('active'));
        
        // Add active class to corresponding link
        const id = entry.target.getAttribute('id');
        const activeLink = container.querySelector(`.js-scroll-link[href="#${id}"]`);
        if (activeLink) activeLink.classList.add('active');
      }
    });
  }, observerOptions);

  sections.forEach(section => {
    observer.observe(section);
  });
});